import React,{useContext} from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { Context } from '../../context/UserContext';


const inputTypeCase = [
    {
        id: 0,
        type: "متن",
        title: ""
    }, {
        id: 1,
        type: "عدد",
        title: ""
    }, {
        id: 2,
        type: "تاریخ",
        title: ""
    }
]


const Index = () => {
    const context = useContext(Context);

    const [path, setPath] = useState([])

    const { readData: readDataService } = useEntityCrud('Service/GetAllServices')
    const { readData: readDataTemplate } = useEntityCrud('Template/GetAllTemplates')
    const [data, setData] = useState([])
    const [serviceList, setServiceList] = useState([]);
    const [isLoading, setLoading] = useState(false);

    const handleManagerID = (value) => {
    }

    useEffect(() => {
        getData();
        readDataService().then(res => {
            setServiceList(res.data.result.map(item => ({ value: item.id, label: item.title })))
        });
    }, [])

    const getData = (searchedData) => {
        setLoading(true)
        const postedData = {
            pageNumber: 1,
            take: 10,
            ...searchedData
        };
        readDataTemplate(postedData).then(res => {
            setLoading(false)
            if (res.data.result) {
                setData(res.data.result);
                // const fieldJson = res.data.result?.map(item => item.fields);
                // const filedsArray = [];
                // res.data.result.map(item => filedsArray.push(JSON.parse(item.fields)));
                // console.log(filedsArray);
                // setPath(oldData => filedsArray);
            } else {
                setData([]);
            }
        });
    }

    console.log(serviceList);

    return (
        <>
            {/*       <div className="page-header m-0 p-0">
                <h1 className="page-title"> قالب ها</h1>
            </div> */}
            <div className="card">
                <div className="card-body">
                    <div className="card">
                        <div className="card-header p-2">
                            <h3 className="card-title">
                                {/*    <i className='fa fa-list px-1'></i> */}
                                قالب ها </h3>
                        </div>
                        <div className="card-body">
                            {context.checkHasPermission('create') ? <Link className="btn btn-primary mb-2" to="create">ایجاد قالب</Link> : ''}
                            <div className="table-responsive">
                                <table className="table table-hover border text-nowrap text-md-nowrap table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th width="1%"  >ردیف</th>
                                            <th>   نام سرویس </th>
                                            <th width="15%">عملیات</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.map((item, index) =>
                                            <tr>
                                                <td className='text-center'>{index + 1}</td>
                                                <td className='d-flex justify-content-between align-items-center'>
                                                    <p style={{ width: "10%" }}> {item.serviceTitle || "ثبت نشده"}</p>
                                                    {/*                                                    
                                                     {serviceList.find(element => element.value === item.serviceId)?.label}
 */}
                                                    <div className="collapse " id={`collapseExample${item.id}`} style={{ flex: "0.75 1 0", margin: "10px 15px 0" }}>
                                                        <div style={{ flex: "1", borderRight: "4px solid red", padding: "0 14px" }}>
                                                            <div >
                                                                <label className='text-danger'>
                                                                    فیلدهای ثبت شده
                                                                </label>
                                                                <form>
                                                                    <div>
                                                                        <div className="card-status" ></div>
                                                                        <div className="row">
                                                                            <div className="col-md-12" style={{ position: "relative", zIndex: "8", paddingRight: "25px" }}>
                                                                                <div className="form-group">
                                                                                    <ul style={{ listStyle: "inside" }}>
                                                                                        {JSON.parse(item.fields).map((field, fi) => (
                                                                                            /*        <div className="d-flex">
                                                                                                       <input type="text" className='form-control my-2 mx-1' placeholder={field.id} key={fi} value= />
                                                                                                       <input type="text" className='form-control my-2' placeholder={field.type} key={fi} value={field.type} />
                                                                                                   </div> */
                                                                                            <li>
                                                                                                {field.title}
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <a
                                                            className="btn btn-purple text-white px-1 py-1 mx-2"
                                                            type="button"
                                                            title='فیلدها'
                                                            data-bs-toggle="collapse"
                                                            href={`#collapseExample${item.id}`}
                                                            role="button"
                                                            aria-expanded="false"
                                                            aria-controls="collapseExample"
                                                            onClick={(value) => handleManagerID(value)}
                                                        >
                                                            <i class="fe fe-list mx-1"></i>
                                                        </a>
                                                    </div>
                                                </td>
                                                <td>
                                                    {context.checkHasPermission('update') ? <Link to={`update/${item.id}`} className="btn btn-icon mb-0 btn-primary  mx-1">
                                                        <i className="fe fe-edit-2"></i>
                                                    </Link> : ''}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div >
                </div>
            </div>
        </>
    );
}

export default Index;